import { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import styles from "./FeedbackModal.module.scss";
import { Loader } from "src/components/Loader";
import { feedback, feedbackSupplier } from "./constants";
// import { Table } from "./Table";
import { Table } from "src/components/Table";
import { Padding } from "@mui/icons-material";
import { feedbackModalConstants } from "../../../constants/constant";
import { ImageViewModal } from "../ImageModal";
import defaultImg from "../../../assets/images/defaultImg.png";
import { baseApiCall } from "src/api/Api";
import { feedbacks_module_apis, packaging_strategy_all_endpoints } from "src/constants/url";
import { commonVaribles } from "src/constants/constVariables";
import CloseIcon from "@mui/icons-material/Close";
import { onResponse } from 'src/redux/features';
import { useDispatch } from "react-redux";
import { IsUserRoleMatch, UpperFirstLetter } from "src/constants/utils";
import useAuthorizationContext from "src/providers/AuthorizationHandler/useAuthorizationContext";

export const FeedbackModal = ({
  open,
  handleClose,
  Modalloader,
  sub_title,
  id,
  plantId
}) => {
  const [image, setImgLink] = useState();
  const [feedbackData, setFeedbackData] = useState([]);
  const [totalData, setTotalData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [loader, setLoader] = useState(true);
  const [feedbackLoader,setFeedbackLoader] = useState(true);
  const [loaderTbl, setLoaderTbl] = useState(true);
  const dispatch = useDispatch();
  const [imageModalIsOpen, setImgModalIsOpen] = useState(false);
  const { user } = useAuthorizationContext();


  const getImgLink = (imgData) => {
    setFeedbackLoader(true);
    setImgLink('');
    baseApiCall({
      url: packaging_strategy_all_endpoints.GET_PRESIGNED_IMAGES,
      requestBody: {
        file_name: imgData,
        img_type: "feedback",
      },
      method: commonVaribles.post,
      onSuccess: (res) => {
        if (res?.data?.result) {
          const xhr = new XMLHttpRequest();
          xhr.open("GET", res.data.result, true);
          xhr.responseType = "blob";
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              const blob = xhr.response;
              const imageUrl = URL.createObjectURL(blob);
              if (blob?.type?.includes('excel') || blob?.type?.includes('spreadsheetml')) {
                const a = document.createElement("a");
                a.href = imageUrl;
                a.download = imgData; // Set the filename here
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                
                setImgModalIsOpen(false);
                setFeedbackLoader(false);

                return;
              }
              setImgLink(imageUrl);
              setFeedbackLoader(false);
            } else if (xhr.readyState === 4) {
              setImgLink(defaultImg);
              setImgModalIsOpen(false);
              setFeedbackLoader(false);
            }
          };
          xhr.send();
        } else {
          setImgLink(defaultImg);
          setFeedbackLoader(false);
        }
      },
      onFailure: () => {
        setImgLink(defaultImg);
        setFeedbackLoader(false);
      },
      errorCall: () => {
        setImgLink(defaultImg);
        setFeedbackLoader(false);
      },
    });
  };

  const ImageViwer = ({ rowData }) => {
    const handleOpen = () => {
      setFeedbackLoader(true);
      setImgModalIsOpen(true);
      if (!rowData) {
        setImgLink(defaultImg);
        return;
      }
      getImgLink(rowData);
    };

    return (
      <div>
        <div className={styles["view-button"]}>
          <div
            style={{ color: "#2162AC", fontWeight: 700 }}
            onClick={handleOpen}
          >
            Preview
          </div>
        </div>
      </div>
    );
  };

  const getFeedbackData = () => {
    baseApiCall({
      url: feedbacks_module_apis.GET_FEEDBACKS_LIST_BY_STRATEGY_ID,
      method: commonVaribles.post,
      requestBody: { strategy_id: id , plant_id:plantId , Skipinterceptors:true },
      onSuccess: (res) => {
        const data = res?.data?.result;
        const modifiedData = data?.map((item) => ({
            ...item,
            dmp_attachment_file: <ImageViwer rowData={item?.dmp_approval_attachment_file_name} />,
            scm_attachment_file: <ImageViwer rowData={item?.scm_approval_attachment_file_name} />,
            logistics_attachment_file: <ImageViwer rowData={item?.logistics_approval_attachment_file_name} />,
          })
        );

        setFeedbackData(modifiedData);
        setLoader(false);
        setLoaderTbl(false);
        dispatch(
          onResponse({
            isToaster: true,
            severity: commonVaribles.success,
            message: res?.data?.message
          })
        );
        if (offset !== 0) {
          let temp = [...feedbackData];
          modifiedData.forEach((element) => {
            temp.push(element);
          });
          setTotalData(modifiedData?.length);
        } else {
          setFeedbackData(modifiedData);
          setTotalData(modifiedData?.length);
        }
      },
      onFailure: () => {
        setLoader(false);
        setLoaderTbl(false);
      },
      errorCall: () => {
        setLoader(false);
        setLoaderTbl(false);
      },
    });
  };

  useEffect(() => {
    getFeedbackData(sub_title);
  }, []);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles["image-container"]}>
          {/* {src && ( */}
          <div className={styles["image-body"]}>
            <div className={styles.countTitleWrapper}>
              <span className={styles.title}>
                Feedbacks
              </span>
              <CloseIcon
                className={styles["cancel-btn"]}
                onClick={handleClose}
              />
            </div>
            {loader ? (<Loader/>):(<div className={`${styles.tablemain}`}>
              <Table
                columns={
                  (IsUserRoleMatch('supplier', user)
                    ? [...feedbackSupplier]
                    : [...feedback])
                  }
                defaultColumns={
                  (IsUserRoleMatch('supplier', user)
                    ? [...feedbackSupplier]
                    : [...feedback])}
                rows={feedbackData}
                rowHeight={38}
                isModal={true}
                removeRowSelection={false}
                pagination={false}
                infiniteScroll={false}
                setTotalData={() => {}}
                onChangeFilterResetTheCheckbox={() => {}}
              />
            </div>)}
          </div>
          {/* )} */}
        </div>
      </Modal>
      {imageModalIsOpen && (
        <ImageViewModal
          src={image}
          open={imageModalIsOpen}
          handleClose={() => setImgModalIsOpen(false)}
          Modalloader={feedbackLoader}
        />
      )}
      <style jsx="true">
        {`
          a {
            text-decoration: none;
            color: inherit;
          }
        `}
      </style>
    </>
  );
};
